import { useQuery } from "@tanstack/react-query"
import { conversationQuestionsQuery } from "../lib/conversationQuestionsQuery"

export function useConversationQuestionsQuery(
  ...args: Parameters<typeof conversationQuestionsQuery>
) {
  return useQuery(conversationQuestionsQuery(...args))
}
